import {
    addFollow,
    FollowCard,
    withFollow,
} from '@eventbrite/follow-organizer-ebui';
import React from 'react';
import { GA_HOME_FEED_CATEGORY } from '../../../../constants/analytics';
import { GASettings, OrganizerProfiles } from '../../../../types/index';
import './OrganizerCards.scss';

interface OrganizerCardsProps {
    profiles: OrganizerProfiles;
    isAuthenticated: boolean;
    bucketKey?: string;
    userId?: string;
    isGDPRCountry: boolean;
    gaSettings: GASettings;
}

const EnhancedFollowCard = withFollow(FollowCard);

const OrganizerList = addFollow(
    ({ organizers }: { organizers: OrganizerProfiles }) => {
        const organizerCards = organizers.map((organizerId) => {
            return (
                <li className="list-item" key={`organizer-${organizerId}`}>
                    <EnhancedFollowCard
                        organizerId={organizerId}
                        style="grid"
                        size="standard"
                        shouldHideDefaultDataPoint={true}
                    />
                </li>
            );
        });

        return <ul className="feed__organizer-list">{organizerCards}</ul>;
    },
);

const OrganizerCards = (props: OrganizerCardsProps) => {
    const { profiles } = props;
    const organizerIds = profiles.map((profile: { id: string }) => profile.id);

    return (
        <OrganizerList
            organizers={organizerIds}
            gaSettings={props.gaSettings}
            gaCategory={GA_HOME_FEED_CATEGORY}
            userId={props.userId}
            isAuthenticated={props.isAuthenticated}
            isGDPRCountry={props.isGDPRCountry}
        />
    );
};

export default OrganizerCards;
